import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Delivery, DeliveryProduct, DeliveryStatus, DeliveryStatusAux, TimePeriods } from 'src/app/models/delivery.schema';
import { Expert, ExpertServices } from 'src/app/models/expert.schema';
import { Partner } from 'src/app/models/partner.schema';
import { Product } from 'src/app/models/product.schema';
import { ServiceModel } from 'src/app/models/service.schems';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { ExpertService } from 'src/app/services/expert.service';
import { PartnerPriorityListService } from 'src/app/services/partner-priority-list.service';
import { PartnerService } from 'src/app/services/partner.service';
import { ProductService } from 'src/app/services/product.service';
import { ProvincesService } from 'src/app/services/provinces.service';
import { Service } from 'src/app/services/service.service';
import { CommanService } from './../../services/comman.service';
import { findProvinceFromAddress } from 'src/app/helpers/find-province-from-address.helper';
import { AdminValetActivityHelpherService } from 'src/app/helpers/admin-valet-activity-helpher.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { setCustomValidators } from 'src/app/helpers/custom-validator-form-helpers';

@Component({
  selector: 'app-shopify-sale-form-dialog',
  templateUrl: './shopify-sale-form-dialog.component.html',
  styleUrls: ['./shopify-sale-form-dialog.component.scss']
})
export class ShopifySaleFormDialogComponent implements OnInit {

  public timePeriods = TimePeriods;
  public showTime: boolean = true;
  public groups: any;
  public partners: any[];
  public experts: Expert[];
  public deliveryStatus = DeliveryStatus;
  public deliveryStatusAux = DeliveryStatusAux;
  public _shopifySaleForm: any;
  public saleData: any;
  public products: any;
  public productss: Product[];
  public readonly formValidationMsgs;
  public tmpBtnDisabled: boolean;
  public pickUpTime: string;
  public from: any;
  public to: any;
  public productData: any[];
  public productDataNew: { product: Product; shopProductSku: string }[] = [];
  public selectedPartner: Partner;
  public selectedPartnerServices: any[] = [];
  public selectedService: any;
  public services: ServiceModel[] = [];
  public previousValues: { startTime: string, endTime: string } = { startTime: '07:00', endTime: '08:00' };
  public selectedProducts: any;
  public TotalSelectedProPrice: any;
  showStartEndTime: boolean = false;
  showPickUpAddress: boolean = false;
  showProductValue: boolean = false;
  showDistanceInput: boolean = false;
  disableAdditionalPriceInput: boolean = false;
  disableValetAdditionalPriceInput: boolean = false;
  pickUpAddressLat: number;
  pickUpAddressLng: number;
  pickUpFTime: any;
  pickUpTTime: any;
  selectedExpert: Expert;
  selectedExpertSalary: any;
  totalDeliveryTime: any = 1;
  selectedExpertServices: any[] = [];
  selectedExpertService: ExpertServices;
  selectedValetAddress: string = '';
  valetAddressLat: number;
  valetAddressLng: number;
  previousValetTimeValues: { valetStartTime: string, valetEndTime: string } = { valetStartTime: '07:00', valetEndTime: '08:00' };
  totalValetTimeDifference: any = 1;
  showValetStartAndEndTime: boolean = false;
  showProductImage: boolean[] = [];
  productImageUrls: string[] = [];
  allProvinces: any[] = [];
  salePartner: any;
  partnerPriorityLists: any[] = [];
  uniqueProductSale: boolean = false;
  availablePartnersListNonUniquePro: any[] = [];
  showPartnersListNonUniquePro: boolean = false;
  proposalBtn: boolean = false;
  selectedVariant: any;
  selectedVariants: any[] = [];
  showProductVariant: boolean[] = [];
  selectedProductsForVariants: any[] = [];
  initialPartners: Partner[];
  initialExperts: Expert[];
  initialProducts: Product[];
  isDeliveryAndPartnerCitySame: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { saleOrder: any },
    private authStatusService: AuthStatusService,
    private partnerService: PartnerService,
    private expertService: ExpertService,
    private deliveryService: DeliveryService,
    private dialogRef: MatDialogRef<ShopifySaleFormDialogComponent>,
    private _snackBar: MatSnackBar,
    private productService: ProductService,
    private commanService:CommanService,
    private adminValetActivityHelpherService: AdminValetActivityHelpherService,
    private commanUsesService: CommanUsesService,
  ) {
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.formValidationMsgs = Delivery.validationMessages;
  }

  async ngOnInit() {
    let data = [];
    let productInfoNew: { product: Product; shopProductSku: string }[] = [];
    this.saleData = this.data.saleOrder;
    this.products = JSON.parse(this.data.saleOrder['lineItems']);
    let shippingAddress = JSON.parse(this.data.saleOrder['shippingAddress']);
    let oldProduct: any;
    for(let product of this.products) {

      // oldProduct = await this.commanUsesService.findProductSaleAutomationProcess(product, shippingAddress);
      // if(oldProduct) {
      //   productInfoNew.push({
      //     product: oldProduct,
      //     shopProductSku: product.sku
      //   })
      // }

      // /*
      if(product.sku != null && product.sku != ''){
        oldProduct = await this.productService.findProduct(product.sku);
        if(oldProduct){
          data.push(oldProduct);
        } else {
          let skuProvince = product?.sku + shippingAddress?.province_code;
          oldProduct = await this.productService.findProduct(skuProvince);
          if(!oldProduct){
            let newProduct = await this.createNewProductWithShopifyProduct(product, shippingAddress);
            data.push(newProduct);
          } else {
            data.push(oldProduct);
          }
        }
      } else{
        let newProduct = await this.createNewProductWithShopifyProduct(product, shippingAddress);
        data.push(newProduct);
      }
      // */

    }
    this.productData = data;
    // this.productDataNew = productInfoNew;
    await this.initialize();
    setCustomValidators(
      this._shopifySaleForm.controls.payAtDelivery,
      this._shopifySaleForm.controls.payAtDeliveryAmount,
      (value) => value === true,
      [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]
    );
  }

  async createNewProduct(product: Product, shippingAddress: any){
    let newProduct: Product = new Object();
    newProduct.name = product.name;
    // newProduct.sku = product?.sku ? product?.sku : [...Array(6)].map(() => 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[Math.floor(Math.random() * 36)]).join('');
    newProduct.sku = `${product?.sku ? product?.sku : ''}${shippingAddress?.province_code}`;
    newProduct.category = [];
    newProduct.line = [];
    newProduct.stock = [];
    newProduct.price = product.price;
    return this.productService.create(newProduct);
  }

  async createNewProductWithShopifyProduct(productInfo: any, shippingAddress: any){
    let obj = {
      "info": {
        "productInfo": productInfo,
        "shippingAddress": shippingAddress,
        "platform": "deluxy"
      }
    }

    let stringifyData = JSON.stringify(obj);
    return await this.commanService.createProductWithShopifyProduct(obj);
  }

  hideShowDeliveryTime(event: any){
    this.showTime = event.target.checked;
  }

  async initialize() {
    this.tmpBtnDisabled = false;
    if (this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')) {
      try {
        /*
        this.productss = (await this.productService.getAllActiveProducts(undefined, undefined, { 'Product.name': 'ASC' })).products;
        this.partners = (await this.partnerService.getAllActivePartners(undefined, undefined, { 'Partner.businessName': 'ASC' })).partners;
        this.experts = (await this.expertService.getAllActiveExperts(undefined, undefined, { 'User.surname': 'ASC', 'User.name': 'ASC' })).experts;
        this.services = await this.service.getAllServices();
        this.allProvinces = await this.provincesService.getAllProvinces();
        this.partnerPriorityLists = await this.partnerPriorityListService.getAllPartnerPriorityLists();
        */
        [this.productss, this.partners, this.experts] = await Promise.all([
          this.productService.getAllActiveProductsForDelivery().then(res => res.products),
          this.partnerService.getAllActivePartnersForDelivery().then(res => res.partners),
          this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts),
        ]);
        this.initialExperts = this.experts;
        this.initialPartners = this.partners;
        this.initialProducts = this.productss;
        this._shopifySaleForm = new FormGroup(Delivery.validation());
        this.patch();
      }catch{}
    }
  }

  setTime(timePeriod){
    if (this.timePeriods[timePeriod]) {
      this._shopifySaleForm.controls.fromTime.setValue(this.timePeriods[timePeriod]['from']);
      this._shopifySaleForm.controls.toTime.setValue(this.timePeriods[timePeriod]['to']);
    }
    else {
      this._shopifySaleForm.controls.fromTime.setValue('');
      this._shopifySaleForm.controls.toTime.setValue('');
    }
  }

  onFileSelect(event: any){
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this._shopifySaleForm.get('ddtFile').setValue(file);
    }
  }

  patch(){
    if(this.saleData.deliveryDate){
      this._shopifySaleForm.controls['deliveryDate'].setValue(new DatePipe('it-IT').transform(this.saleData.deliveryDate, 'yyyy-MM-dd'));
    }
    let beforeFromTime: any;
    if(this.saleData.deliveryTime){
      let [from, to] = this.saleData.deliveryTime.split("-");
      let fromTime = `${from}:00`;
      let toTime = `${parseInt(from)+1}:00`;
      this.from = `${from}:00:00`;
      this.to = `${parseInt(from)+1}:00:00`;
      this._shopifySaleForm.controls['fromTime'].setValue(fromTime);
      this._shopifySaleForm.controls['toTime'].setValue(toTime);
      /* For Pickuptime 1 hour before delivery time */
      let fromHour = parseInt(from);
      let beforeFromHour = (fromHour === 0 ? 23 : fromHour - 1);
      let beforeToHour = fromHour;
      beforeFromTime = `${beforeFromHour.toString().padStart(2, '0')}:00-${beforeToHour.toString().padStart(2, '0')}:00`;
      /* For Pickuptime 1 hour before delivery time */
    } else {
      this.from = `07:00:00`;
      this.to = `08:00:00`;
      this._shopifySaleForm.controls['fromTime'].setValue('07:00');
      this._shopifySaleForm.controls['toTime'].setValue('08:00');
      /* For Pickuptime 1 hour before delivery time */
      beforeFromTime = `06:00:00-07:00:00`;
      /* For Pickuptime 1 hour before delivery time */
    }
    this._shopifySaleForm.controls['pickUpTime'].setValue(beforeFromTime);
    this._shopifySaleForm.controls['surname'].setValue(this.saleData.lastName);
    this._shopifySaleForm.controls['name'].setValue(this.saleData.firstName);
    this._shopifySaleForm.controls['receiverPhone'].setValue(this.saleData.phone);
    this._shopifySaleForm.controls['senderName'].setValue(this.saleData.senderName);
    this._shopifySaleForm.controls['senderSurname'].setValue(this.saleData.senderSurname);
    this._shopifySaleForm.controls['senderPhone'].setValue(this.saleData.senderPhone);
    this._shopifySaleForm.controls['address'].setValue(this.saleData.address);
    this._shopifySaleForm.controls['notes'].setValue(this.saleData.notes);
    this._shopifySaleForm.controls['personalizeSaleNotes'].setValue(this.saleData.personalizeNotes);
    // this._shopifySaleForm.controls['deluxyDelivery'].setValue(true);
    // this._shopifySaleForm.controls['requestExpert'].setValue(true);
    this._shopifySaleForm.controls['intercom'].setValue(this.saleData.intercom);
    // this._shopifySaleForm.controls['ddtNumber'].setValue(this.saleData.orderId);
    this._shopifySaleForm.controls['ddtNumber'].setValue(this.saleData.actualOrderId);
    /* Set products */
    const control = <FormArray>this._shopifySaleForm.get('deliveryProducts');
    control.clear();
    this.productData.forEach((product, key) => {
      control.push(this.patchValues(product, key));
    });
    for(let p of this.partners){
      if(p.businessName.toLowerCase() == this.saleData.vendor.toLowerCase()){
        this._shopifySaleForm.controls.partner.controls.id.setValue(p.id);
        this.selectedPartner = p;
        this.selectedPartnerServices = this.selectedPartner?.partnerServices;
        let service = this.selectedPartnerServices.find((services) => {
          return services?.service?.pricingModel?.toLowerCase() === 'sales'
        });
        this._shopifySaleForm.controls.service.setValue(service?.service?.id);
        this._shopifySaleForm.controls.pickUpAddress.setValue(this.selectedPartner?.address);
        this.handleServiceChange(service?.service?.id);
        //this.filterProducts();
        break;
      }
    }
    // /* Set products */
    // const control = <FormArray>this._shopifySaleForm.get('deliveryProducts');
    // control.clear();
    // this.productData.forEach((product, key) => {
    //   control.push(this.patchValues(product, key));
    // });

  }

  patchValues(deliveryProduct: DeliveryProduct, key){

    //change here
    let productForm = Delivery.productFormGroup();
    let additionalInfoParsed: any[] = [];
    if (this.saleData?.flexiblePrice != null && typeof this.saleData?.flexiblePrice === 'string') {
      const rawFp = String(this.saleData.flexiblePrice).trim();
      if (rawFp) {
        try {
          const parsed = JSON.parse(rawFp);
          additionalInfoParsed = Array.isArray(parsed) ? parsed : [];
        } catch {
          additionalInfoParsed = [];
        }
      }
    }
    //till here
    /*
    console.log("this.saleData", this.saleData)
    console.log("this.saleData?.flexiblePrice", this.saleData?.flexiblePrice)
    console.log("additionalInfo", additionalInfoParsed);
    */
    const additionalInfo = additionalInfoParsed[key];
    let flexiblePrice = (additionalInfo && additionalInfo?.product?.flexiblePrice ? (additionalInfo?.product?.flexiblePrice || 0) : (deliveryProduct?.price || 0));
    if (deliveryProduct['id']){
      // patchValue: product group also has deliveryWithoutCommision — setValue requires every key
      productForm.controls.product.patchValue(
        {
          id: deliveryProduct['id'], 
          quantity: this.products[key].quantity,
          flexiblePrice: flexiblePrice,
        }
      );
    }
    return productForm;
  }

  addProduct() {
    const control = <FormArray>this._shopifySaleForm.get('deliveryProducts');
    control.push(Delivery.productFormGroup());
  }

  removeProduct(index: number) {
    const control = <FormArray>this._shopifySaleForm.get('deliveryProducts');
    this.showProductImage[index] = false;
    this.productImageUrls[index] = '';
    control.removeAt(index);
    this.setProductValue();
  }

  onSubmit(){
    this.tmpBtnDisabled = true;
    let delivery: any = (new FormGroupToObject()).transform(this._shopifySaleForm);

    if (!delivery?.pickUpAddress || delivery.pickUpAddress.trim() === '') {
      this.commanUsesService.showSnackBar(`Assicurati che l'indirizzo di ritiro non sia vuoto.`);
      return;
    }

    delivery.flexiblePrice =  JSON.stringify(delivery?.deliveryProducts);
    delivery.saleId = this.saleData.orderId;
    delivery.orderId = this.saleData.actualOrderId;
    delivery.realOrderNumber = this.saleData?.realOrderNumber;
    delivery.primaryIdOfSale = this.saleData?.id;
    delivery.shop = 'ShopifySale';
    delivery.customer = null;
    let ddtfile = null;
    if(delivery.ddtFile){
      ddtfile = delivery.ddtFile;
      delete delivery.ddtFile;
    }
    let promiseResult = this.deliveryService.createDeliveryViaShopifyOrder(delivery);
    promiseResult.then(async (data: Delivery) => {
      this.saleData = data;
      await this.adminValetActivityHelpherService.createOrUpdateActivitiesNewFunction(data);
      await this.adminValetActivityHelpherService.checkForExpertDeliveryRule(data);
      if(ddtfile){
        this.saleData = await this.uploadDdt(this.saleData.id).catch((err) => {
          this.errorMessage(`Errore nella 'creazione della' consegna`);
        });
      }
      this.successMessage(`Consegna creata con successo. ${ + this.saleData.id} `);
      this.dialogRef.close({ delivery: this.saleData });
    }).catch((err: any) => {
      // this.uniqueProductSale = false;
      this.errorMessage(`Errore nella 'creazione della' consegna`);
    })
  }

  uploadDdt(deliveryId: number) {
    return this.deliveryService.updateDeliveryDdt(
      deliveryId,
      this._shopifySaleForm.get('ddtFile').value
    );
  }

  errorMessage(msg: string){
    this._snackBar.open(`${msg}`,
      'Chiudi',
      {
        direction: 'ltr',
        duration: 2000,
        horizontalPosition: 'center',
        politeness: 'assertive',
        verticalPosition: 'top',
      }
    );
  }

  successMessage(msg: string){
    this._snackBar.open(`${msg}`,
      'Chiudi',
      {
        direction: 'ltr',
        duration: 2000,
        horizontalPosition: 'center',
        politeness: 'assertive',
        verticalPosition: 'top',
      }
    );
  }

  setDeliveryStatus(idExpert){
    this._shopifySaleForm.controls.status.setValue(this.deliveryStatus.assigned);
    this.selectedExpert = this.experts.find((expert) => expert?.id == idExpert);
    this.selectedExpertServices = this.selectedExpert?.expertServices;
    this.expertServiceAndSalary();
  }

  expertServiceAndSalary(){
    if(this.selectedExpert){
      if(["fixedprice", "sales"].includes(this.selectedService?.service?.pricingModel?.toLowerCase())){
        this.selectedExpertService = this.selectedExpert?.expertServices.find((expertService: any) => {
          let data = expertService?.service?.serviceType?.toLowerCase() === "fixedpricesalary";
          return data;
        })
        this.calculateFixedPriceValetSalary();
      } else if(this.selectedService?.service?.pricingModel?.toLowerCase() === "hourlyrate") {
        this.selectedExpertService = this.selectedExpert?.expertServices.find((expertService: any) => {
          let data = expertService?.service?.serviceType?.toLowerCase() === "hourlyratesalary";
          return data;
        });
        this.calculateHourlyRateValetSalary();
      }
      this._shopifySaleForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);
    }
  }

  async getAddress(place: any) {
    if (!this._shopifySaleForm) return;
    this._shopifySaleForm.controls.address.touched = true;
    this._shopifySaleForm.controls.address.setValue(place.formatted_address || place.name || '');
    this._shopifySaleForm.controls.latitude.setValue(place.geometry?.location?.lat() || '');
    this._shopifySaleForm.controls.longitude.setValue(place.geometry?.location?.lng() || '');
    let province: string = findProvinceFromAddress(place);
    if(!province) {
      alert("Province is not found with filled address, Please enter the address again.");
      return false;
    }

    /* Filter partners and experts according to delivery address province */
    this.filterPartnersAndExpertsByProvince(province);
    /* Filter partners and experts according to delivery address province */

    this._shopifySaleForm.controls.province.setValue(province);

    if(this.selectedPartner) {
      let pickUpAddress: string;
      if(this._shopifySaleForm.controls.pickUpAddress.value != '' || this._shopifySaleForm.controls.pickUpAddress.value != null) {
        pickUpAddress = this._shopifySaleForm.controls.pickUpAddress.value;
      } else {
        pickUpAddress= this.selectedPartner ? this.selectedPartner?.address : '';
      }
      this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
      this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity((place.formatted_address || place.name), pickUpAddress);
      await this.geocodePickupAddress(pickUpAddress);
    }

    if((this.selectedService?.service?.pricingModel == 'fixedprice') || (this.selectedService?.service?.pricingModel == 'corporate')){
      // this.geocodePickupAddress(this._shopifySaleForm.controls.pickUpAddress.value);
      this.handleDistanceChange(Number(this._shopifySaleForm.controls.distance.value));
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary'){
      await this.calculateFixedPriceValetSalary();
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'hourlyratesalary'){
      await this.calculateTimeDifference();
    }
    if(this.selectedService?.service?.pricingModel == 'sales') {
      this.setProductValue();
    }
  }

  filterPartnersAndExpertsByProvince(province: string){

    this.partners = this.initialPartners.filter((partner) =>
      partner.partnerProvinces.some((partnerProvince) =>
        partnerProvince?.province?.provinceCode?.toLowerCase() === province?.toLowerCase()
      )
    );

    this.experts = this.initialExperts.filter((partner) =>
      partner.expertProvinces.some((partnerProvince) =>
        partnerProvince?.province?.provinceCode?.toLowerCase() === province?.toLowerCase()
      )
    );

  }

  directions(event:any){
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this._shopifySaleForm.controls.address.value}`, '_blank');
  }

  handlePartnerChange(partnerId: any){
    if(this.partners){
      this.selectedPartner = this.partners.find((partner) => {
        return partner.id == partnerId;
      });
    }
    this.selectedPartnerServices = this.selectedPartner?.partnerServices;
    let pickUpAddress = (this.selectedPartner ? this.selectedPartner?.address : '');
    this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
    if (this.selectedPartnerServices) {
      this.selectedService = this.selectedPartnerServices.map(service => {
          return { label: service.name, value: service.id };
        });
    }
  }

  async handlePartnerChangeDropDown(partnerId: any){
    this._shopifySaleForm.controls.service.setValue(null);
    this.reset();
    if(this.partners){
      this.selectedPartner = this.partners.find((partner) => {
        return partner.id == partnerId;
      });
    }

    /* Filter products according to selected, deluxy and no partner */
    //this.filterProducts();
    /* Filter products according to selected, deluxy and no partner */

    this.selectedPartnerServices = this.selectedPartner?.partnerServices;
    let pickUpAddress = (this.selectedPartner ? this.selectedPartner?.address : '');
    this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
    if (this.selectedPartnerServices) {
      this.selectedService = this.selectedPartnerServices.map(service => {
          return { label: service.name, value: service.id };
        });
    }

    this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity(this._shopifySaleForm.controls.address.value, pickUpAddress);
    await this.geocodePickupAddress(pickUpAddress);

  }

  filterProducts() {
    const selectedPartnerId = Number(this.selectedPartner?.id);
    this.productss = this.initialProducts
      .filter((product) => {
        const partnerId = product?.partner?.id;
        return (
          Number(partnerId) === selectedPartnerId ||
          Number(partnerId) === 128 ||
          partnerId == null ||
          partnerId != null
        );
      })
      .sort((a, b) => {
        const getPriority = (product: any): number => {
          const partnerId = Number(product?.partner?.id);
          if (partnerId === selectedPartnerId) return 0; // highest priority
          if (partnerId === 128) return 1;                // middle
          return 2;                                        // lowest
        };

        return getPriority(a) - getPriority(b);
      });
  }

  reset(){
    this._shopifySaleForm.controls.pickUpAddress.setValue(null);
    this._shopifySaleForm.controls.startTime.setValue(null);
    // this._shopifySaleForm.controls.distance.setValue(null);
    this._shopifySaleForm.controls.endTime.setValue(null);
    this._shopifySaleForm.controls.price?.setValue(null);
    this._shopifySaleForm.controls.productValue?.setValue(null);
    this._shopifySaleForm.controls.service?.setValue(null);
    this._shopifySaleForm.controls.hours.setValue(0);
    this._shopifySaleForm.controls.requestExpert.setValue(false);
    this._shopifySaleForm.controls.deluxyDelivery.setValue(false);
    this.showStartEndTime = false;
    this.showProductValue = false;
    this.showPickUpAddress= false;
    this.showDistanceInput= false;
  }

  async geocodePickupAddress(pickUpAddress: string) {
    try {
      const geocoder = new google.maps.Geocoder();
      const results = await new Promise<any>((resolve, reject) => {
        geocoder.geocode({ 'address': pickUpAddress }, (results, status) => {
          if (status === 'OK') {
            resolve(results);
          } else {
            reject(status);
          }
        });
      });

      if (results && results.length > 0) {
        this.pickUpAddressLat = results[0].geometry?.location?.lat() || '';
        this.pickUpAddressLng = results[0].geometry?.location?.lng() || '';
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._shopifySaleForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._shopifySaleForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        const fixedAddressLatLng = new google.maps.LatLng(this.pickUpAddressLat, this.pickUpAddressLng);
        const selectedAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
        const distanceMatrixService = new google.maps.DistanceMatrixService();
        if (this.pickUpAddressLat && this.pickUpAddressLng && deliveryAddLat && deliveryAddLng) {
          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [fixedAddressLatLng],
              destinations: [selectedAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          // console.log('getAddressdistanceInKm', distanceInKm)
          this._shopifySaleForm.controls.distance.setValue(distanceInKm.toFixed(2));
          this.handleDistanceChange(distanceInKm);
        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
          return;
        }
      } else {
        alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
        return;
      }
    } catch (error) {
      // console.log('Error', error.message);
      alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
      return;
    }
  }

  handleServiceChange(event: any){

    this.selectedService = this.selectedPartnerServices.find((item) => {
      return item?.service?.id == event;
    });

    this._shopifySaleForm.controls.serviceType.setValue(this.selectedService?.service?.pricingModel);
    this._shopifySaleForm.controls.serviceName.setValue(this.selectedService?.service?.serviceName);

    this._shopifySaleForm.controls.startTime.setValue(this.previousValues.startTime);
    this._shopifySaleForm.controls.endTime.setValue(this.previousValues.endTime);
    let pickUpAddress: string;
    if(this._shopifySaleForm.controls.pickUpAddress.value != '' || this._shopifySaleForm.controls.pickUpAddress.value != null) {
      pickUpAddress = this._shopifySaleForm.controls.pickUpAddress.value;
    } else {
      pickUpAddress= this.selectedPartner ? this.selectedPartner?.address : '';
    }


    if(this.selectedService?.service?.pricingModel === 'fixedprice'){
      this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
      this._shopifySaleForm.controls.price.setValue(this.selectedService?.price);
      this.handleDistanceChange(Number(this._shopifySaleForm.controls.distance.value));
      this._shopifySaleForm.controls.startTime.setValue(null);
      this._shopifySaleForm.controls.endTime.setValue(null);
      this._shopifySaleForm.controls.productValue.setValue(null);
      // this._shopifySaleForm.controls.distance.setValue(null);
      this._shopifySaleForm.controls.hours.setValue(0);
      this._shopifySaleForm.controls.valetStartTime.setValue(null);
      this._shopifySaleForm.controls.valetEndTime.setValue(null);
    }

    if(this.selectedService?.service?.pricingModel === 'hourlyrate'){
      // this._shopifySaleForm.controls.distance.setValue(null);
      this._shopifySaleForm.controls.startTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.endTime.setValue(this.previousValues.endTime);
      this._shopifySaleForm.controls.fromTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.toTime.setValue(this.previousValues.endTime);
      this._shopifySaleForm.controls.price.setValue(this.selectedService?.price);
      this._shopifySaleForm.controls.productValue.setValue(null);
      this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
      this.totalValetTimeDifference = 1;
      this._shopifySaleForm.controls.valetStartTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.valetEndTime.setValue(this.previousValues.endTime);
      this.previousValetTimeValues.valetStartTime = this._shopifySaleForm.value.startTime;
      this.previousValetTimeValues.valetEndTime = this._shopifySaleForm.value.endTime;
    }

    if(this.selectedService?.service?.pricingModel === 'sales'){
      this._shopifySaleForm.controls.pickUpAddress.setValue(pickUpAddress);
      this._shopifySaleForm.controls.startTime.setValue(null);
      // this._shopifySaleForm.controls.distance.setValue(null);
      this._shopifySaleForm.controls.endTime.setValue(null);
      this._shopifySaleForm.controls.hours.setValue(0);
      this._shopifySaleForm.controls.valetStartTime.setValue(null);
      this._shopifySaleForm.controls.valetEndTime.setValue(null);
      this.setProductValue();
    }
    let flexbleDelivery: boolean = this.selectedService?.service?.pricingModel === 'fixedprice';
    let deluxyDelivery: boolean = this.selectedService?.service?.pricingModel === 'sales';
    this._shopifySaleForm.controls.requestExpert.setValue(flexbleDelivery);
    this._shopifySaleForm.controls.deluxyDelivery.setValue(deluxyDelivery);
    this.showStartEndTime = this.selectedService?.service?.pricingModel === 'hourlyrate';
    this.showProductValue = this.selectedService?.service?.pricingModel === 'sales';
    this.showPickUpAddress = this.selectedService?.service?.pricingModel === 'fixedprice';
    this.showDistanceInput = this.selectedService?.service?.pricingModel === 'fixedprice';
    this.expertServiceAndSalary();
  }

  async getPickUpAddress(place: any) {
    if(this.selectedService?.service?.pricingModel === 'fixedprice'){
      try {
        if (!this._shopifySaleForm) return;
        this._shopifySaleForm.controls.pickUpAddress.touched = true;
        this._shopifySaleForm.controls.pickUpAddress.setValue(place.formatted_address || place.name || '');
        let pickUpAddLat: any;
        let pickUpAddLng: any;
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._shopifySaleForm.controls.pickUpAddress.value) {
          const pickUpAddressResult = await this.getLatLngByAddress(this._shopifySaleForm.controls.pickUpAddress.value);
          pickUpAddLat = pickUpAddressResult[0]?.geometry?.location?.lat() || '';
          pickUpAddLng = pickUpAddressResult[0]?.geometry?.location?.lng() || '';
          this.pickUpAddressLat = pickUpAddLat;
          this.pickUpAddressLng = pickUpAddLng;
        }

        if (this._shopifySaleForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._shopifySaleForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        this.isDeliveryAndPartnerCitySame = await this.commanUsesService.checkDeliveryAndPartnerAddressCity((this._shopifySaleForm.controls.address.value), (place.formatted_address || place.name));

        if (pickUpAddLat && pickUpAddLng && deliveryAddLat && deliveryAddLng) {
          const pickUpAddressLatLng = new google.maps.LatLng(pickUpAddLat, pickUpAddLng);
          const deliveryAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
          const distanceMatrixService = new google.maps.DistanceMatrixService();

          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [pickUpAddressLatLng],
              destinations: [deliveryAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          // console.log('distanceInKm', distanceInKm)
          this._shopifySaleForm.controls.distance.setValue(distanceInKm.toFixed(2));
          this.handleDistanceChange(distanceInKm);
        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
          return;
        }
      } catch (error) {
        // console.log('Error', error.message)
        alert("Can not calculate distance. Try again with valid address, Check both pickupaddress and delivery address");
        return;
      }
    } else {
      this._shopifySaleForm.controls.pickUpAddress.setValue(place.formatted_address || place.name || '');
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary'){
      this.calculateFixedPriceValetSalary();
    }
    if(this.selectedService?.service?.pricingModel == 'sales') {
      this.setProductValue();
    }
  }

  pickUpDirections(event: Event) {
    event.preventDefault();
    window.open(`https://www.google.com/maps/dir//${this._shopifySaleForm.controls.pickUpAddress.value}`, '_blank');
  }

  handleDistanceChange(distance: any){
    let price: any = 0;
    if((this.selectedService?.service?.pricingModel?.toLowerCase() === 'fixedprice' || (this.selectedService?.service?.pricingModel?.toLowerCase() === 'corporate'))){
      if(distance > this.selectedPartner?.kmIncluded && this.selectedPartner?.kmIncluded){
        let extraKm = (distance - this.selectedPartner?.kmIncluded);
        price = parseFloat(this.selectedService?.price) + (extraKm * this.selectedService?.extraKmPrice);
      } else {
        price = parseFloat(this.selectedService?.price)
      }
    }

    if (!this.isDeliveryAndPartnerCitySame) {
      const kmPrice = this.selectedPartner?.extraOutSideCityKmPrice || 0;
      const distance = Number(this._shopifySaleForm.controls?.distance?.value) || 0;
      const extraOutsideCityValue = kmPrice * distance;
      price = extraOutsideCityValue;
    }

    this._shopifySaleForm.controls.price?.setValue(parseFloat(price)?.toFixed(2));
    this._shopifySaleForm.controls.distance?.setValue(distance.toFixed(2));
  }

  /*
  handleStartTimeChange(value: string) {
    this._shopifySaleForm.controls.startTime.setValue(value);
    this.calculateTimeDifference();
  }
  */

  handleStartTimeChange(value: string) {
    this._shopifySaleForm.controls.startTime.setValue(value);
    const startTime = new Date('1970-01-01T' + this._shopifySaleForm.value?.startTime + ':00');
    const endTime = new Date(startTime.getTime() + 3600000);
    const endTimeString = this.formatTime(endTime);
    this._shopifySaleForm.controls.endTime.setValue(endTimeString);
    this._shopifySaleForm.controls.fromTime.setValue(value);
    this._shopifySaleForm.controls.toTime.setValue(endTimeString);
    this.calculateTimeDifference();
  }

  formatTime(date: Date): string {
    return date.toTimeString().slice(0, 5); // Format as HH:MM
  }

  handleEndTimeChange(value: string) {
    this._shopifySaleForm.controls.endTime.setValue(value);
    this._shopifySaleForm.controls.toTime.setValue(value);
    this.calculateTimeDifference();
  }

  calculateTimeDifference() {
    const startTime = new Date('1970-01-01T' + this._shopifySaleForm.value?.startTime + ':00');
    const endTime = new Date('1970-01-01T' + this._shopifySaleForm.value?.endTime + ':00');
    const timeDiff = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDiff / 3600000);
    if(hours <= 0){
      alert('Minimum one hour is required');
      this._shopifySaleForm.controls.startTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.endTime.setValue(this.previousValues.endTime);
      this._shopifySaleForm.controls.fromTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.toTime.setValue(this.previousValues.endTime);
      this._shopifySaleForm.controls.valetStartTime.setValue(this.previousValues.startTime);
      this._shopifySaleForm.controls.valetEndTime.setValue(this.previousValues.endTime);
      return false;
    }
    const minutes = Math.floor((timeDiff % 3600000) / 60000);
    // console.log(`Time Difference: ${hours} hours ${minutes} minutes`);
    // let totalTime = `${hours}.${minutes}`;
    const totalTime = hours + minutes / 60;
    this.totalDeliveryTime = totalTime.toFixed(2);
    this.totalValetTimeDifference = totalTime.toFixed(2);
    let price = hours !== 0 ? Number(this.selectedService?.price) * Number(this.totalDeliveryTime) : Number(this.selectedService?.price)
    this._shopifySaleForm.controls.price.setValue(price?.toFixed(2));
    this._shopifySaleForm.controls.hours.setValue(this.totalDeliveryTime);
    this.previousValues.startTime = this._shopifySaleForm.value.startTime;
    this.previousValues.endTime = this._shopifySaleForm.value.endTime;
    this.previousValetTimeValues.valetStartTime = this._shopifySaleForm.value.startTime;
    this.previousValetTimeValues.valetEndTime = this._shopifySaleForm.value.endTime;
    this.expertServiceAndSalary();
  }

  handleProductChange(index?: number, item?: any) {
    try {
      let selectedProduct = this.productss.find(product => product?.id == item);
      const variants = selectedProduct?.productVariants || [];
      this.selectedProductsForVariants[index] = selectedProduct;
      this.showProductImage[index] = selectedProduct?.image ? true : false;
      this.productImageUrls[index] = selectedProduct?.image ? selectedProduct.image : '';
      if (variants.length > 0) {
        this.showProductVariant[index] = variants.length > 0;
        const defaultVariant = variants[0];
        this.onVariantSelect(index, defaultVariant);
      }
      this.handleFlexibleProductPrice(index);
      this.setProductValue();
    } catch (error) {
      console.log("ERROR_IN_handleProductChange", error?.message);
    }
  }

  onVariantSelect(index: number, variant: any) {
    try {
      this.selectedVariants[index] = variant;
      const control = this._shopifySaleForm.get('deliveryProducts') as FormArray;
      const group = control.at(index) as FormGroup;
      group.get('productVariant')?.setValue(variant.id);
      this.handleFlexibleProductPrice(index);
      this.setProductValue();
    } catch (error) {
      console.log("ERROR_IN_onVariantSelect", error?.message);
    }
  }

  handleProductQuantityChange(){
    this.setProductValue();
  }

  setProductValue(){
    try {
      if(this.selectedService?.service?.pricingModel === 'sales'){
        this.selectedProducts = this._shopifySaleForm.controls.deliveryProducts?.value;
        this.TotalSelectedProPrice = this.selectedProducts?.map(item => {
          const product: Product = this.productss.find(p => p.id == item.product.id);
          const quantity = Number(item?.product?.quantity);
          let price = Number(product?.price);
  
          const flexiblePriceControl = this._shopifySaleForm.get('deliveryProducts')
            .get([this.selectedProducts.indexOf(item)])
            .get('product')
            .get('flexiblePrice');
  
          if (this._shopifySaleForm.get('isFlexiblePrice').value && flexiblePriceControl?.value != null) {
            price = Number(flexiblePriceControl.value);
          } else {
            if (item?.productVariant) {
              let variant = product?.productVariants.find((v) => v.id === item.productVariant);
              price = Number(variant?.variantPrice);
            }
          }
  
          if (!isNaN(price) && !isNaN(quantity)) {
            return price * quantity;
          }
  
          /*
          if(item?.productVariant) {
            let variant = product?.productVariants.find((v) => v.id === item.productVariant);
            price       = Number(variant?.variantPrice);
            if (!isNaN(price) && !isNaN(quantity)) {
              return price * quantity;
            }
          } else {
            if (!isNaN(price) && !isNaN(quantity)) {
              return price * quantity;
            } 
          }
            */
        }).reduce((acc, curr) => acc + curr, 0);
  
        // let price = this.TotalSelectedProPrice ? (this.selectedService?.price * this.TotalSelectedProPrice)/100 : 0;
        let price = this.TotalSelectedProPrice ? ((Number(this.selectedService?.price) || 0) * (Number(this.TotalSelectedProPrice) || 0)) / 100 : 0;
        /*
        if(!this.isDeliveryAndPartnerCitySame) {
          const kmPrice = this.selectedPartner?.extraOutSideCityKmPrice || 0;
          const distance = Number(this._shopifySaleForm.controls?.distance?.value) || 0;
          const extraOutsideCityValue = kmPrice * distance;
          price = extraOutsideCityValue;
        }
        */
  
        this._shopifySaleForm.controls.price?.setValue(Number(price).toFixed(2));
        this._shopifySaleForm.controls.productValue?.setValue(this.TotalSelectedProPrice ? this.TotalSelectedProPrice : 0);
      }
    } catch (error) {
      console.log("ERROR_IN_setProductValue", error?.message);
    }
  }

  handlePickUpFlexbleTime(){
    if(this.pickUpFTime && this.pickUpTTime){
      let time = this.pickUpFTime + "-" + this.pickUpTTime;
      this._shopifySaleForm.controls.pickUpTime?.setValue(time);
    }
  }

  // patchPickUpFlexbleTime(){
  //   let [startTime, endTime] = this.delivery.pickUpTime.split("-");
  //   this.pickUpFTime = startTime;
  //   this.pickUpTTime = endTime;
  // }

  handleBillable(event: any){
    this._shopifySaleForm.controls.bilable?.setValue(event.target.checked);
    this.checkDeliveryIsBillable();
  }

  checkDeliveryIsBillable(){
    if(!this._shopifySaleForm.controls.billable.value){    // Delivery is not billable
      this._shopifySaleForm.controls.price.setValue(0);
      this._shopifySaleForm.controls.additionalPrice.setValue(0);
    }
    this.disableAdditionalPriceInput = !this._shopifySaleForm.controls.billable.value;
  }

  handleValetServiceChange(valetServiceId: number){
    this.selectedExpertService = this.selectedExpertServices.find(expertService => expertService?.id == valetServiceId);
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary'){
      this.calculateFixedPriceValetSalary();
    }
    if(this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'hourlyratesalary'){
      this.calculateHourlyRateValetSalary();
    }
  }

  handlePayable(event: any){
    this._shopifySaleForm.controls.bilable?.setValue(event.target.checked);
    this.checkDeliveryIsPayable();
  }

  checkDeliveryIsPayable(){
    if(!this._shopifySaleForm.controls.payable.value){    // Delivery is not payable
      this.setToZeroIfNotPayable();
    }
    this.disableValetAdditionalPriceInput = !this._shopifySaleForm.controls.payable.value;
  }

  setToZeroIfNotPayable(){
    this._shopifySaleForm.controls.expertSalary.setValue(0);
    this._shopifySaleForm.controls.valetAdditionalPrice.setValue(0);
  }

  async calculateFixedPriceValetSalary() {
    try {
      if (this.selectedExpert) {
        this._shopifySaleForm.controls.valetStartTime.setValue(null);
        this._shopifySaleForm.controls.valetEndTime.setValue(null);
        this.showValetStartAndEndTime = false;

        let pickUpAddLat: any;
        let pickUpAddLng: any;
        let deliveryAddLat: any;
        let deliveryAddLng: any;

        if (this._shopifySaleForm.controls.pickUpAddress.value) {
          const pickUpAddressResult = await this.getLatLngByAddress(this._shopifySaleForm.controls.pickUpAddress.value);
          pickUpAddLat = pickUpAddressResult[0]?.geometry?.location?.lat() || '';
          pickUpAddLng = pickUpAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (this._shopifySaleForm.controls.address.value) {
          const deliveryAddressResult = await this.getLatLngByAddress(this._shopifySaleForm.controls.address.value);
          deliveryAddLat = deliveryAddressResult[0]?.geometry?.location?.lat() || '';
          deliveryAddLng = deliveryAddressResult[0]?.geometry?.location?.lng() || '';
        }

        if (pickUpAddLat && pickUpAddLng && deliveryAddLat && deliveryAddLng) {
          const pickUpAddressLatLng = new google.maps.LatLng(pickUpAddLat, pickUpAddLng);
          const deliveryAddressLatLng = new google.maps.LatLng(deliveryAddLat, deliveryAddLng);
          const distanceMatrixService = new google.maps.DistanceMatrixService();

          const response: any = await new Promise((resolve, reject) => {
            distanceMatrixService.getDistanceMatrix({
              origins: [pickUpAddressLatLng],
              destinations: [deliveryAddressLatLng],
              travelMode: google.maps.TravelMode.DRIVING,
            }, (response, status) => {
              if (status === google.maps.DistanceMatrixStatus.OK) {
                resolve(response);
              } else {
                reject(status);
              }
            });
          });

          const distance = response.rows[0].elements[0].distance?.value;
          const distanceInKm = distance / 1000;
          let valetSalary: number = 0;

          if (this.selectedExpertService?.service?.serviceType?.toLowerCase() === 'fixedpricesalary') {
            if (this.selectedExpert?.minimumKmIncluded && distanceInKm > this.selectedExpert?.minimumKmIncluded) {
              const extraKm = distanceInKm - this.selectedExpert?.minimumKmIncluded;
              valetSalary = this.selectedExpertService.salary + (extraKm * Number(this.selectedExpertService.minimumKmPrice));
            } else {
              valetSalary = this.selectedExpertService.salary;
            }
          }

          if(!this.isDeliveryAndPartnerCitySame) {
            const kmPrice = this.selectedExpert?.extraOutSideCityKmPrice || 0;
            const distance = Number(this._shopifySaleForm.controls?.distance?.value) || 0;
            const extraOutsideCityValue = kmPrice * distance;
            valetSalary = extraOutsideCityValue;
          }

          this._shopifySaleForm.controls.expertSalary?.setValue(valetSalary.toFixed(2));
          this._shopifySaleForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);

          if (!this._shopifySaleForm.controls.payable.value) {
            this.setToZeroIfNotPayable();
          }

          /*
          console.log('distanceInKm', distanceInKm);
          console.log('valetSalary', this._shopifySaleForm.controls.expertSalary?.value);
          console.log('this.selectedExpertService?.service?.serviceType', this.selectedExpertService?.service?.serviceType);
          */

        } else {
          alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
          return;
        }
      }
    } catch (error) {
      console.error('Error calculating distance:', error);
      alert("Can not calculate distance. Try again with valid address, Check both pickup address and delivery address");
    }
  }

  async getLatLngByAddress(address: string){
    const geocoder = new google.maps.Geocoder();
    const results = await new Promise<any>((resolve, reject) => {
      geocoder.geocode({ 'address': address }, (results, status) => {
        if (status === 'OK') {
          resolve(results);
        } else {
          reject(status);
        }
      });
    });
    return results;
  }

  handleValetStartTimeChange(value: string){
    this._shopifySaleForm.controls.valetStartTime.setValue(value);
    const startTime = new Date('1970-01-01T' + this._shopifySaleForm.controls.valetStartTime.value + ':00');
    const endTime = new Date(startTime.getTime() + 3600000);
    const endTimeString = this.formatTime(endTime);
    this._shopifySaleForm.controls.valetEndTime.setValue(endTimeString);
    this.calculateValetTimeDifference();
  }

  handleValetEndTimeChange(value: string){
    this._shopifySaleForm.controls.valetEndTime.setValue(value);
    this.calculateValetTimeDifference();
  }

  calculateValetTimeDifference() {
    const startTime = new Date('1970-01-01T' + this._shopifySaleForm.controls.valetStartTime.value + ':00');
    const endTime = new Date('1970-01-01T' + this._shopifySaleForm.controls.valetEndTime.value + ':00');
    const timeDiff = endTime.getTime() - startTime.getTime();
    const hours = Math.floor(timeDiff / 3600000);
    if(hours <= 0){
      alert('Minimum one hour is required');
      this._shopifySaleForm.controls.valetStartTime.setValue(this.previousValetTimeValues.valetStartTime);
      this._shopifySaleForm.controls.valetEndTime.setValue(this.previousValetTimeValues.valetEndTime);
      return false;
    }
    const minutes = Math.floor((timeDiff % 3600000) / 60000);
    // let totalTime = `${hours}.${minutes}`;
    const totalTime = hours + minutes / 60;
    this.totalValetTimeDifference = totalTime.toFixed(2);
    // console.log('this.totalValetTimeDifference', this.totalValetTimeDifference)
    this.previousValetTimeValues.valetStartTime = this._shopifySaleForm.controls.valetStartTime.value;
    this.previousValetTimeValues.valetEndTime = this._shopifySaleForm.controls.valetEndTime.value;
    this.calculateHourlyRateValetSalary();
  }

  calculateHourlyRateValetSalary(){
    if(this.selectedExpert){
      this.showValetStartAndEndTime = true;
      this._shopifySaleForm.controls.valetStartTime.setValue(this.previousValetTimeValues.valetStartTime);
      this._shopifySaleForm.controls.valetEndTime.setValue(this.previousValetTimeValues.valetEndTime);
      let valetSalary = (this.totalValetTimeDifference * this.selectedExpertService?.salary)?.toFixed(2);
      this._shopifySaleForm.controls.expertSalary.setValue(valetSalary);
      this._shopifySaleForm.controls.expertServiceId.setValue(this.selectedExpertService?.id);
      if(!this._shopifySaleForm.controls.payable.value){
        this.setToZeroIfNotPayable();
      }
      // console.log('valetSalary', this._shopifySaleForm.controls.expertSalary?.value)
      // console.log('this.selectedExpertService?.service?.serviceType', this.selectedExpertService?.service?.serviceType);
    }
  }

  async getAllActivePartnersByProvinceId(provinceId: number|string){
    let data = await this.partnerService.getAllActivePartnersByProvinceId(provinceId);
  }

  isOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const products of this._shopifySaleForm.value.deliveryProducts) {
      if (products.product.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId; // assuming your item has a 'disabled' property
  }

  getErrorMessages(): string[] {
    const errorMessages: string[] = [];

    Object.keys(this._shopifySaleForm.controls).forEach(key => {
      const controlErrors = this._shopifySaleForm.get(key)?.errors;
      if (controlErrors) {
        const fieldValidationMessages = Delivery.validationMessages[key];
        if (fieldValidationMessages) {
          Object.keys(controlErrors).forEach(errorKey => {
            const messageObj = fieldValidationMessages.find((msg) => msg.type === errorKey);
            if (messageObj) {
              if (key === 'address' && !errorMessages.includes('address')) {
                errorMessages.push('address');
              } else if (key !== 'address') {
                errorMessages.push(key);
              }
            }
          });
        }
      }
    });

    const customerIdErrors = this._shopifySaleForm.get('customer.id')?.errors;
    if (customerIdErrors) {
      errorMessages.push('customer');
    }

    const deliveryProductsArray = <FormArray>this._shopifySaleForm.get('deliveryProducts');
    deliveryProductsArray.controls.forEach((productGroup, index) => {
      const productControl: any = productGroup.get('product');
      const quantityControl = productGroup.get('quantity');

      if (productControl) {
        productControl.updateValueAndValidity();
      }

      if (quantityControl) {
        quantityControl.updateValueAndValidity();
      }
      const productErrors = productControl.controls.id.errors;
      const quantityErrors = productControl.controls.quantity.errors;

      if (productErrors) {
        errorMessages.push('product');
      }

      if (quantityErrors) {
        errorMessages.push('quantity');
      }
    });

    return errorMessages;
  }

  translateErrorMessage(error: string): string {
    const errorMessages: { [key: string]: string } = {
      address: 'VALIDARE INDIRIZZO',
      name: 'NOME',
      surname: 'COGNOME',
      intercom: 'CITOFONO',
      deliveryDate: 'DATA',
      pickUpTime: 'ORA RITIRO',
      service: 'SERVIZIO',
      product: 'PRODOTTO',
      receiverPhone: 'VALIDARE DESTINATARIO TELEFONO',
      senderPhone: 'VALIDARE MITTENTE TELEFONO',
      smsPhoneNo: 'VALIDARE SMS TELEFONICI',
      customer: 'CUSTOMER'
    };
    return errorMessages[error] || '';
  }

  handleFlexiblePayment(event: any) { }

  handleFlexibleProductPrice(index: number) {
    try {
      this.selectedProducts = this._shopifySaleForm.controls.deliveryProducts?.value ?? [];
      const item = this.selectedProducts[index];
      const product: Product = this.productss.find(p => p.id === item.product.id);
      let quantity = item?.product?.quantity ? Number(item?.product?.quantity) : 1;
      let price = product?.price ? Number(product?.price) : 0;

      const flexiblePriceControl = this._shopifySaleForm.get('deliveryProducts')
        .get([index])
        .get('product')
        .get('flexiblePrice');

      if (item?.productVariant) {
        let variant = product?.productVariants.find((v) => v.id === item.productVariant);
        price = Number(variant?.variantPrice);
        if (!isNaN(price) && !isNaN(quantity)) {
          flexiblePriceControl.setValue(price); 
        }
      } else {
        if (!isNaN(price) && !isNaN(quantity)) {
          flexiblePriceControl.setValue(price); 
        }
      }
    } catch (error) {
      console.log("Error updating flexible prices:", error);
    }
  }
  

  handleManualPriceUpdate(index: number, value: number) {
    try {
      const selectedProduct = this.selectedProducts[index];
      const product: Product = this.productss.find(p => p.id === selectedProduct.product.id);
      let quantity = selectedProduct.product?.quantity ? Number(selectedProduct.product.quantity) : 1;

      if (isNaN(value)) {
        return;
      }

      const flexiblePriceControl = this._shopifySaleForm.get('deliveryProducts')
        .get([index])
        .get('product')
        .get('flexiblePrice');
      
      flexiblePriceControl?.setValue(value);

      this.setProductValue();
    } catch (error) {
      console.log("Error in handleManualPriceUpdate:", error);
    }
  }
  
}
